import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Layout,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Row,
  Col,
  message,
  Form,
  Select,
  Spin,
  DatePicker,
  AutoComplete,
  Switch,
  TimePicker,
  Upload,
  Collapse,
  List,
  Progress,
} from "antd";
import IntlMessages from "../util/IntlMessages";

import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";
import {
  ArrowLeftOutlined,
  ShoppingCartOutlined,
  CloudUploadOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  CheckOutlined,
  WarningOutlined,
  InfoCircleOutlined,
  CaretRightOutlined,
  CaretLeftOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Icon } from "@ant-design/compatible";
import { InputGroup } from "reactstrap";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { userLogOut } from "../appRedux/actions/Auth";
import { setCommonConfigs } from "../appRedux/actions/CommonData";
import {
  getDecryptID,
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  StringIsNullOrEmpty,
} from "../appRedux/actions/GlobalMethods";
import { PRODUCT_SCREEN } from "../constants/Pages";
import { BEHAVIOUR_TYPE } from "../Services/DataServices";
import ProductImg from "../assets/images/products.png";
import CustomScrollbars from "../util/CustomScrollbars";
import { REACT_APP_BUS_FIRST_NAME } from "../constants/StoreSetting";
import ds from "../Services/DataServices";
import { loadGeneralImportProducts } from "../appRedux/actions";
import { stat } from "fs";
import NotAllowedComponent from "./NotAllowedComponent";
const Panel = Collapse.Panel;
const Dragger = Upload.Dragger;

const bgcolor = "#e5eaed";
const { Footer } = Layout;
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      //offset: 0,
    },
    sm: {
      span: 16,
      //offset: 0,
    },
    md: {
      span: 24,
      //  offset: 0,
    },
  },
};

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 },
  },
};

const GeneralProductImport = (props) => {
  const [getExcelFileName, setExcelFileName] = useState("");
  const [percent, setPercent] = useState(0);
  const [status, setStatus] = useState("");

  const history = useHistory();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  //#region useState
  // const [getLoader, setLoader] = React.useState(isAddMode ? false : true);
  const [getLoader, setLoader] = React.useState(true);
  const [isRegistering, SetisRegistering] = React.useState(false);
  const [selected, setselected] = useState([]);
  const [getIsPartialCount, setIsPartialCount] = useState(true);
  const [options, setOptions] = useState([]);
  const [getSearchProd, setSearchProd] = useState([]);
  const [getShortCurr, setShortCurr] = useState("");
  const [getCurrSymbol, setCurrSymbol] = useState("");
  const [getIsCountNameChange, setIsCountNameChange] = useState(false);
  const [getShowInActive, setShowInActive] = useState(true);
  const [getIsDisableCreate, setIsDisableCreate] = useState(true);
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true);
  const [getIsDisableDelete, setIsDisableDelete] = useState(true);
  const [getIsAllowRead, setIsAllowRead] = useState(false);
  const [getAccessLoading, setAccessLoading] = useState(true);
  const [getRights, setRights] = useState([]);
  const [getPermissions, setPermissions] = useState([]);
  const [getCurrData, setCurrData] = useState({
    currencyCode: "",
    currencySymbol: "",
  });
  const [fileList, setfileList] = useState([]);
  const [getGeneralProductTemplateURL, setGeneralProductTemplateURL] =
    useState("");
  const [getCustomerValidateData, setCustomerValidateData] = useState([]);
  const [getCustomerImportType, setCustomerImportType] = useState(1); //1. For Uploader , 2 For Header Columns Component . 3 For Data Columns Component. 4 For Upload Done
  const [getCustomerImportExecID, setCustomerImportExecID] = useState(0);
  const [getImportProducts, setImportProducts] = useState([]);
  //#endregion useState

  //#region useSelector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );
  //#endregion useSelector

  //#region useEffect

  React.useEffect(() => {
    let mounted = true;

    if (mounted) {
      const commonData = getReduxCommonSetting;

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {};

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData;
        setCurrSymbol(currencyData.currencySymbol);
        setShortCurr(currencyData.currencyCode);
        setCurrData(currencyData);
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData);

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData);

          setAccessLoading(false);
        } else {
          toInitialState();

          setAccessLoading(false);
        }
      }
    }

    return () => (mounted = false);
  }, [getReduxCommonSetting]);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      dispatch(setCommonConfigs(PRODUCT_SCREEN));
      getGeneralProductTemplateData();
    }
    return () => {
      mounted = false
      dispatch(loadGeneralImportProducts([]));
    };
  }, []);

  function setupRightsPermissions(rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights);
    } else {
      setRights([]);
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions);
    } else {
      setPermissions([]);
    }
    if (rpData.read) {
      setIsAllowRead(true);
    } else {
      setIsAllowRead(false);
    }

    if (rpData.create) {
      setIsDisableCreate(false);
    } else {
      setIsDisableCreate(true);
    }

    if (rpData.update) {
      setIsDisableUpdate(false);
    } else {
      setIsDisableUpdate(true);
    }

    if (rpData.delete) {
      setIsDisableDelete(false);
    } else {
      setIsDisableDelete(true);
    }
  }
  function toInitialState() {
    setRights([]);

    setPermissions([]);

    setIsAllowRead(false);

    setIsDisableCreate(true);

    setIsDisableUpdate(true);

    setIsDisableDelete(true);

    setAccessLoading(true);
  }

  //#endregion useEffect

  //#region Api Services

  async function getGeneralProductTemplateData() {
    setLoader(true);
    const getImportData = ds.getGeneralProductImportTemplateURLandGenerate(
      BEHAVIOUR_TYPE.GET
    );
    await getImportData
      .then((response) => {
        if (response) {
          if (response.isGenerated) {
            setLoader(false);
            setGeneralProductTemplateURL(response.productTemplateXLSURL);
            //getLastCustomerImportStatusData()
          } else {
            setLoader(true);
          }
        }
      })
      .catch((error) => {
        notAllowMsgCheck(error);
        setLoader(true);
        if (error.response && error.response.status === 401) {
          notAllowMsgCheck(error);
          setTimeout(() => {
            dispatch(userLogOut("store.getState()"));
          }, 3000);
        } else {
          notAllowMsgCheck(error);
        }
      });
  }
  async function getLastCustomerImportStatusData() {
    setLoader(true);
    const getImportData = ds.getLastCustomerExecStatus(
      false,
      BEHAVIOUR_TYPE.GET
    );
    await getImportData
      .then((response) => {
        if (response) {
          if (!StringIsNullOrEmpty(response.fileName)) {
            if (response.isCompleted) {
              setLoader(false);
              if (response.isShowMsg) {
                message.success(
                  `This Excel file (${response.fileName})  import successfully`,
                  10
                );
              }
            } else {
              setLoader(true);
              message.success(`${response.fileName} importing products`, 10);
              setExcelFileName(
                `This excel file "${response.fileName}" already in progress.`
              );
            }
          } else {
            setLoader(false);
          }
        }
      })
      .catch((error) => {
        notAllowMsgCheck(error);
        setLoader(true);
        if (error.response && error.response.status === 401) {
          setExcelFileName("");
          notAllowMsgCheck(error);
          setTimeout(() => {
            dispatch(userLogOut("store.getState()"));
          }, 3000);
        } else {
          notAllowMsgCheck(error);
        }
      });
  }
  async function postGeneralProductImport(body) {
    setLoader(true);
    await ds
      .postGeneralProductImportExcel(body, BEHAVIOUR_TYPE.POST)
      .then((res) => {
        let obj = res.data.data;
        setLoader(false);
        setCustomerValidateData(obj);

        if (obj.isHeaderValid && obj.isDataValid) {
          setTimeout(() => {
            const apiResponse = 100; // Replace this with the actual API response
            setPercent(apiResponse);
          }, 1000);
          setCustomerImportType(3);
          if (obj.productsData) {
            setImportProducts(obj.productsData);
          }

          //setCustomerImportExecID(obj.bulkImportExecutionID)
          // if (obj.isDataValid) {
          // } else {
          //   setCustomerImportType(3); // 2 For Data Columns Component
          //    message.error(obj.errorMesage);
          // }
        } else {
          setCustomerImportType(2); // 2 For Header Columns Component
          setfileList([]);
          //message.success("Product Import excel validated successfully. We'll notify whenever products are imported on your store");
          message.error(obj.errorMessage);
          setStatus("exception");
        }
      })
      .catch((error) => {
        setStatus("exception");
        setLoader(false);
        notAllowMsgCheck(error);
        message.error("Something went wrong...");
      });
  }
  async function postCustomerImportStatusUpdate(body) {
    setLoader(true);
    await ds
      .postProductImportStatusData(body, BEHAVIOUR_TYPE.POST)
      .then((res) => {
        let obj = res.data.data;
        setLoader(false);
        if (obj) {
          message.success(
            "Your customers are importing. Reload customers listing page after 5 minutes."
          ); // We'll notify you when it's finished.
          history.push("/dashboard/customers/addcustomer");
        } else {
          message.error("Error to importing Customers");
          history.push("/dashboard/customers/addcustomer");
        }
      })
      .catch((error) => {
        setLoader(false);
        notAllowMsgCheck(error);
        message.error("Something went wrong...");
      });
  }

  //#endregion Api Services

  //#region Calculated  Function Start

  //#endregion Calculated  Function Start

  //#region Change Functions, OnClick Form Save

  //#endregion Change Functions, OnClick Form Save

  //#region Table Columns

  //#endregion Table Columns

  const uploadProps = {
    name: "file",
    multiple: false,
    fileList: fileList.length !== 0 ? fileList : [],
    onChange(info) {
      const isExcelFile =
        info.file.type === "text/csv" ||
        info.file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (isExcelFile) {
        if (
          info.file.status === "removed" &&
          !info.file.uid.toString().includes("rc-upload")
        ) {
          handleUpload(info);
        } else {
          handleUpload(info);
        }
      } else {
        message.error("You can only upload excel or csv file!");
      }
    },
  };

  const handleUpload = ({ fileList }) => {
    ////;
    if (fileList.length <= 1) {
      setfileList(fileList);
      const formData = new FormData();
      if (fileList[0] != undefined) {
        var file = fileList[0].originFileObj;
        formData.append("excelFormFile", file);

        postGeneralProductImport(formData);
      }
    }
  };

  const ProductUploader = ({ uploadPropData }) => {
    return (
      <>
        <div className='upload-wrapper'>
        
        <p>
          <IntlMessages id="products.main.productimport.youcan" />{" "}
          <a
            // href="file:///D:/DakarPOSResources/resources/skymart/productImports/template/Dakar product import template.xlsx"
            href={getGeneralProductTemplateURL}
            download
            target="_blank"
          >
            <FileExcelOutlined />{" "}
            <IntlMessages id="products.main.productimport.downloadaspreedsheet" />{" "}
          </a>
          <IntlMessages id="products.main.productimport.or" />{" "}
          <a
            // href="file:///D:/DakarPOSResources/resources/skymart/productImports/template/Dakar product import template.xlsx"
            href={getGeneralProductTemplateURL}
            download
            target="_blank"
          >
            <FileTextOutlined />{" "}
            <IntlMessages id="products.main.productimport.csv" />{" "}
          </a>
          <IntlMessages id="products.main.productimport.toget" />
        </p>

        <div className='upload-box'>

        {props && props.isDraggerActive ? (
          <Dragger
            {...uploadPropData}
            className="gx-mt-3"
            beforeUpload={() => false}
          >
            <p className="ant-upload-drag-icon">
              <CloudUploadOutlined style={{ color: "#08c", width: "5em" }} />
            </p>
            <p className="ant-upload-text">
              <IntlMessages id="components.generalproductimport.uploadaspreedsheet" />
            </p>
            <p className="ant-upload-hint">
              <IntlMessages id="products.main.productimport.draganddropafile" />
            </p>
          </Dragger>
        ) : (
          ""
        )}

        <div className='gx-text-center upload-btn'>
          <Upload {...uploadPropData}>
            <Button size="large" type="primary" className="">
              <IntlMessages id="products.main.productimport.chooseafileto" />
            </Button>
          </Upload>
        </div>

        </div>

        </div>
      </>
    );
  };

  const ProductHeaderColumns = ({ productColumnsData }) => {
    return (
      <>
        <div className="div-flow text-right">
          <Button
            className=""
            type="primary"
            onClick={() => backtoUpload(1)}
            size="large"
          >
            <IntlMessages id="products.main.productimport.backtoupload" />
          </Button>
        </div>
        <h2 className='dk-text-main-heading'>
          <IntlMessages id="products.main.productimport.thereare" />{" "}
          {productColumnsData &&
            productColumnsData.filter((x) => x.isValid == false).length}{" "}
          <IntlMessages id="products.main.productimport.columnsarenotmatched" />
        </h2>
        <CustomScrollbars className="gx-module-content-scroll">
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 4,
              lg: 4,
              xl: 6,
              xxl: 3,
            }}
            itemLayout={"vertical"}
            dataSource={productColumnsData}
            renderItem={(item) => (
              <List.Item>
                <Card
                  title={
                    item.isValid ? (
                      <>
                        <div className="gx-text-center gx-px-3 gx-pt-3">
                          <div className="gx-d-flex gx-justify-content-around gx-align-items-center gx-mb-3">
                            <div className="gx-module-logo">
                              <CheckOutlined style={{ color: "#1dd444" }} />
                              <h2 className="dk-text-sub-heading dk-import-text-margin">
                                {" "}
                                {item.headerName}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="gx-text-center gx-px-3 gx-pt-3">
                          <div className="gx-d-flex gx-justify-content-around gx-align-items-center gx-mb-3">
                            <div className="gx-module-logo">
                              <WarningOutlined style={{ color: "#d4301d" }} />{" "}
                              <h2 className="dk-text--negative dk-import-text-margin">
                                <IntlMessages id="products.main.productimport.unmatchedcolumns" />{" "}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  }
                >
                  {!item.isValid ? (
                    <>
                      <h2 className="dk-text--negative"> {item.headerName}</h2>
                      <p>
                        <IntlMessages id="products.main.productimport.kindlyfixedthiscolumnname" />
                      </p>
                    </>
                  ) : (
                    <p>
                      <IntlMessages id="products.main.productimport.nochangesneeded" />
                    </p>
                  )}
                </Card>
              </List.Item>
            )}
          />
        </CustomScrollbars>
      </>
    );
  };
  const ProductTempComponent = ({}) => {
    return (
      <>
     
        <h2 className='dk-text-main-heading mt-3 mb-3 div-flow'>
          <IntlMessages id="components.generalproductimport.productexcelisready" />
        </h2>

        <div className='gx-text-center div-flow pro-excel-btn'>
          <Button
            size="large"
            type="primary"
            className="dk-btn-cancel"
            onClick={() => {
              handleCustomerStatus(false);
            }}
          >
            <IntlMessages id="products.main.productimport.cancelimport" />
          </Button>
          <Button
            className=""
            type="primary"
            onClick={() => backtoUpload(1)}
            size="large"
            icon={<CaretLeftOutlined className="dk-btn-icon-align" />}
          >
            <IntlMessages id="products.main.productimport.backtoupload" />
          </Button>
          <Button
            onClick={() => {
              handleCustomerStatus(true);
            }}
            size="large"
            type="primary"
            className=""
          >
            <IntlMessages id="products.main.productimport.continuewithimport" />
          </Button>
        </div>
      </>
    );
  };
  const productExcelDatacolumns = [
    {
      title: <IntlMessages id="products.main.productimport.issue" />,
      dataIndex: "issue",
    },
    {
      title: <IntlMessages id="products.main.productimport.affectedrows" />,
      dataIndex: "affectedrows",
    },
    {
      title: <IntlMessages id="products.main.productimport.howtofix" />,
      dataIndex: "fix",
    },
  ];

  const productColumnsData1 = [
    {
      key: "1",
      issue: "John Brown",
      affectedrows: "￥300,000.00",
      fix: "New York No. 1 Lake Park",
    },
    {
      key: "2",
      issue: "John Brown",
      affectedrows: "￥300,000.00",
      fix: "New York No. 1 Lake Park",
    },
    {
      key: "3",
      issue: "John Brown",
      affectedrows: "￥300,000.00",
      fix: "New York No. 1 Lake Park",
    },
  ];

  const backtoUpload = (e) => {
    setfileList([]);
    setCustomerImportType(e);
  };
  const handleCustomerStatus = (isContinueImport) => {
    if (isContinueImport) {
      dispatch(loadGeneralImportProducts(getImportProducts));
      setCustomerImportType(4);
    } else {
      dispatch(loadGeneralImportProducts([]));
      setCustomerImportType(1);
    }
    // let body = {
    //   BulkImportExecutionID: getCustomerImportExecID,
    //   IsContinueImport: isContinueImport
    // }
    // postCustomerImportStatusUpdate(body)
  };
  const ProductDataColumns = ({ productColumnsData }) => {
    return (
      <>
        <div className="div-flow text-right">
          <Button
            className=""
            type="primary"
            onClick={() => backtoUpload(1)}
            size="large"
          >
            <IntlMessages id="products.main.productimport.backtoupload" />
          </Button>
        </div>
        <h2 className='dk-text-main-heading'>
          <IntlMessages id="products.main.productimport.thereare" />{" "}
          {productColumnsData &&
            productColumnsData.filter((x) => x.isValid == false).length}{" "}
          <IntlMessages id="products.main.productimport.columnsarenotmatched" />
        </h2>
        <Card
          title={
            <>
              {" "}
              <InfoCircleOutlined />{" "}
              <IntlMessages id="products.main.productimport.thingsyoucoulddoimprove" />{" "}
              {3}{" "}
              <IntlMessages id="products.main.productimport.thingsyoucoulddoimprove" />
            </>
          }
        >
          <Table
            className="gx-table-responsive"
            columns={productExcelDatacolumns}
            dataSource={productColumnsData1}
            bordered
            footer={() => (
              <Row>
                <Col md={6}>
                  <p className="">
                    <IntlMessages id="products.main.productimport.downloadafile" />
                  </p>
                </Col>
                <Col md={18}>
                  <div style={{ textAlign: "right", marginBottom: "16px" }}>
                    <Button
                      className=""
                      type="primary"
                      size="large"
                    >
                      <IntlMessages id="products.main.productimport.downloadspreadsheettofix" />
                    </Button>
                    <Button
                      className="custom-btn-addbtn"
                      type="primary"
                      size="large"
                    >
                      <IntlMessages id="products.main.productimport.continueanyway" />
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
          />
        </Card>
      </>
    );
  };
  const CircularBar = () => {
    return (
      <>
        <Card
          title={null}
          extra={null}
         className="noborder"
        >
         
          <div className="Progress-card div-flow mt-3">
          <p> <IntlMessages id="components.generalproductimport.successfullyimported" /></p>
          <Progress className="m-0" type="circle" percent={percent} status={status} />
          <div className="div-flow mt-3">
          <Button
              className=""
              type="primary"
              onClick={() => backtoUpload(1)}
              size="large"
              icon={<CaretLeftOutlined className="dk-btn-icon-align" />}
            >
              <IntlMessages id="products.main.productimport.backtoupload" />
            </Button>
            </div>
          </div>
        </Card>
      </>
    );
  };
  return (
    <>
      {getIsAllowRead ? (
        <div>
          {getLoader ? (
            <>
              <h3 className="">{getExcelFileName}</h3>
              <Skeleton count={12} height={30} />
            </>
          ) : (
            <>
              <Spin
                tip={<IntlMessages id="sell.cashlisting.cashloading" />}
                spinning={isRegistering}
                size="large"
              >
                <div className="DragBox-wrapper">
                  {getCustomerImportType == 1 ? (
                    <ProductUploader uploadPropData={uploadProps} />
                  ) : (
                    ""
                  )}

                  {getCustomerImportType == 2 ? (
                    !getCustomerValidateData.isHeaderValid ? (
                      <ProductHeaderColumns
                        productColumnsData={
                          getCustomerValidateData &&
                          getCustomerValidateData.productExcelHeaderColumns !=
                            null
                            ? getCustomerValidateData.productExcelHeaderColumns
                            : []
                        }
                      />
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}

                  {getCustomerImportType == 3 ? <ProductTempComponent /> : ""}
                  {getCustomerImportType == 4 ? <CircularBar /> : ""}
                </div>
              </Spin>
            </>
          )}
        </div>
      ) : (
        <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
      )}
    </>
  );
};

export default GeneralProductImport;
